/**
 * Manage Stripe Customer
 */
import Ajax from '@/lib/ajax_wrapper'

/**
 * Read a Stripe customer
 *
 * @returns {promise}
 */
export function readStripeCustomerData(companyId) {
  return Ajax.request({
    url: `/admin/companies/${companyId}/payments/customers`,
    method: 'GET'
  })
}

/**
 * Attach a payment method to a Stripe customer
 *
 * @returns {promise}
 */
export function addPaymentMethodData() {
  return Ajax.request({
    url: `/`,
    method: 'POST'
  })
}

/**
 * Set payment method as Stripe customers default
 *
 * @returns {promise}
 */
export function updateDefaultPaymentMethodData() {
  return Ajax.request({
    url: `/`,
    method: 'PATCH'
  })
}
